import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { DatePickerInput, DATEPICKER_TYPE } from "widgets/datetime";
import { DateTimeSuggestionsHeader } from "widgets/others";

import { Base } from "../base";

export function DateTime(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const inputRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(
    function onValueChange() {
      setCurrentValue(value || null);
      inputRef.current && inputRef.current.blur();
    },
    [value, row, pos]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(e) => {
        inputRef.current.focus();
      }}
      type="datetime"
      // doubleClickToEdit={true}
    >
      <DatePickerInput
        dateString={currentValue}
        includeTime={true}
        ref={inputRef}
        readOnly={column.readOnly}
        onOpen={() => {
          baseRef.current.startEditing(currentValue);
        }}
        onChange={(value) => {
          setCurrentValue(value);
          baseRef.current.dataChanged(value);
          baseRef.current.dataCompleted();
        }}
        onBlur={() => {
          baseRef.current.dataChanged(currentValue);
          baseRef.current.dataCompleted();
        }}
        type={DATEPICKER_TYPE.MINIMAL}
        headerRenderer={DateTimeSuggestionsHeader(props)}
      />
    </Base>
  );
}

DateTime.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  suggestionList: PropTypes.array,
  row: PropTypes.any,
  pos: PropTypes.any
};
